<template>
    <nav>
        <v-navigation-drawer v-model="open" width="300" app>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="title">
                        {{ authed ? identity.customer : brand.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="authed">
                        {{ identity.displayName || identity.email }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list dense>
                <v-list-item link to="/" v-if="authed">
                    <v-list-item-action>
                        <v-icon>mdi-view-dashboard</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Home</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="authed">
                    <v-list-item-action>
                        <v-icon>mdi-chart-areaspline-variant</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="grey--text">{{ brand.name }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link :to="{ name: 'ProductView', params: { id: p.id } }" v-for="p in products" :key="p.id" no-action>
                    <v-list-item-action />
                    <v-list-item-content>
                        <v-list-item-title>{{ p.name }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/admin/customers" v-if="admin">
                    <v-list-item-action>
                        <v-icon>mdi-cash-100</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Customers</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/admin/jobs" v-if="admin">
                    <v-list-item-action>
                        <v-icon>mdi-av-timer</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Jobs</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/account" v-if="authed">
                    <v-list-item-action>
                        <v-icon>mdi-account</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Account</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/login" v-if="!authed">
                    <v-list-item-action>
                        <v-icon>mdi-login</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Log in</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="logout()" v-if="authed">
                    <v-list-item-action>
                        <v-icon>mdi-login</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Log out</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <div class="pa-2" align="center">
                        <v-menu open-on-hover top offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn small depressed rounded v-on="on" class="grey--text">v 1.3.0</v-btn>
                        </template>
                        <v-list>
                        <v-list-item>
                            <v-list-item-title><small>v 1.3.0 - 19.07.2020</small></v-list-item-title>
                        </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>
        </v-navigation-drawer>

        <v-app-bar app color="primary" dark>
            <v-app-bar-nav-icon @click="toggleMenu()"></v-app-bar-nav-icon>
            <div class="d-flex align-center" style="flex:1 1 auto">
                <v-img alt="Logo" class="shrink mr-2" contain :src="brand.logo" transition="scale-transition" width="38" />
                <v-toolbar-title class="font-weight-condensed-thin headline bryans-logo">
                    {{ brand.name }}
                </v-toolbar-title>
                <div style="margin-left:10px; font-size:14px; opacity: .5;" v-if="authed">
                    {{ identity.customer }}
                </div>
                <v-spacer />
                <v-progress-circular :indeterminate="true" v-if="loading"  />
            </div>
        </v-app-bar>
    </nav>
</template>
<style lang="scss">
    .v-application .headline.bryans-logo {
        font-family: var(--branding-font, "Roboto, sans-serif") !important;
        letter-spacing: 1px !important;
    }
</style>
<script>
    import store from "@/services/store";
    import theme from "@/services/theme";

    export default {
        data: () => ({
            menu: true,
            brand: {
                name: theme.branding.name,
                logo: theme.branding.logo
            }
        }),
        methods: {
            toggleMenu() {
                this.menu = !this.menu;
            },
            logout() {
                store.commit("deauth");

                this.$router.push("/login");
            }
        },
        computed: {
            identity: () => store.state.id,
            authed: () => store.state.authed,
            loading: () => store.state.loading,
            products: () => store.state.products,
            admin: () => (store.state.authed && store.state.id.admin),
            open: {
                get() { return (store.state.inited && this.menu); },
                set(value) { this.menu = value; }
            }
        }
    }
</script>
